import {createStrokeSVG} from './TEMPLATE'

// tabler: file-x
export const PageX_Stroke2_Corner0_Rounded_Large = createStrokeSVG({
  paths: [
    'M14 3v4a1 1 0 0 0 1 1h4',
    'M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2',
    'M10 12l4 4m0 -4l-4 4',
  ],
  viewBox: '2 2 20 20',
  strokeWidth: 2,
})
